import type { ReactNode } from "react";
import { Helmet } from "react-helmet-async";

type NoHeadLayoutProps = {
  children?: ReactNode;
};

const NoHeadLayout = ({ children }: NoHeadLayoutProps) => {
  return (
    <div className="h-full bg-gradient-to-br from-gray-50 to-gray-100">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Helmet>
      <div className="flex grow overflow-y-auto h-full w-full">{children}</div>
    </div>
  );
};

export default NoHeadLayout;
